import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { ReactNode, useState } from "react";
import styled from "styled-components";
import Loader from "../../../components/Loader.js";
import { Outlet, useNavigate } from "react-router-dom";
import { RelayInfoProvider } from "./contexts";
import { useRelayInfo } from "./hooks";

const buttonStyle = {
  minWidth: "150px",
  padding: "2px 5px",
};

const tabGroups = [
  {
    key: "basic-details",
    value: "basic-details",
    label: "Basic Details",
  },
  {
    key: "user-management",
    value: "user-management/users",
    label: "User Management",
  },
  {
    key: "instructions",
    value: "instructions",
    label: "Instructions",
  },
  {
    key: "custom-field-options",
    value: "custom-field-options",
    label: "Custom Field Options",
  },
];

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

const RelaySettingsContent: React.FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const { isLoading, relayInfo } = useRelayInfo();
  const navigate = useNavigate();

  // get current url
  const currentUrl = window.location.pathname;

  const defaultGroup = tabGroups.find((group) =>
    currentUrl.includes(group.key)
  )?.value;

  const [group, setGroup] = useState(defaultGroup || "basic-details");

  const handleChange = (e: React.MouseEvent<HTMLElement>, newGroup: string) => {
    if (newGroup !== null) {
      navigate(newGroup);
      setGroup(newGroup);
    }
  };

  const control = {
    value: group,
    onChange: handleChange,
    exclusive: true,
  };

  if (isLoading) return <Loader />;

  return (
    <StyledContainer>
      {!relayInfo && (
        <div>
          No Relay tenant found, please contact support for assistance:{" "}
          <a
            href={encodeURIComponent(
              `mailto:support@monolithforensics.com?subject=[Monolith Support] Relay Setup`
            )}
          >
            support@monolithforensics.com
          </a>
        </div>
      )}
      {relayInfo && (
        <>
          <div style={{ marginBottom: 15, display: "flex" }}>
            {/*weird mui ts bug*/}
            {/*@ts-ignore*/}
            <ToggleButtonGroup
              size="small"
              {...control}
              style={{ margin: "auto" }}
            >
              {tabGroups.map((group) => (
                <ToggleButton
                  value={group.value}
                  key={group.key}
                  size="small"
                  disableRipple={true}
                  style={buttonStyle}
                >
                  {group.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>
          {children}
          <Outlet />
        </>
      )}
    </StyledContainer>
  );
};

export const RelaySettingsPage: React.FC<{ children?: ReactNode }> = ({
  children,
}) => {
  return (
    <RelayInfoProvider>
      <RelaySettingsContent>{children}</RelaySettingsContent>
    </RelayInfoProvider>
  );
};
